<div class="h-full  w-full overflow-y-auto overflow-x-hidden p-6  ">
    <div class="flex w-full justify-between">
        <div class="flex flex-row items-center ">
            <span class="text-[#AEB9E1] font-normal md:text-lg sm:text-sm tracking-[0.2%]"> Site name : </span>
            @if (selectedPlant) { <span class="text-white font-normal md:text-lg sm:text-sm tracking-[2%] ml-1.5">
                {{selectedPlant.plantName}}
            </span>}
        </div>
        @if (largeScalePlantStats ) {
        <div> <span class="text-white font-normal text-base">Last updated :{{largeScalePlantStats.lastUpdatedTimestamp +
                ' IST'}}
            </span> </div>}
    </div>

    <div class="flex flex-col flex-grow w-full gap-1.5">
        @if (largeScalePlantStats ) {

        <div class="grid w-full gap-1.5 sm:grid-cols-4 md:grid-cols-6 mt-3 max-w-full">

            <div
                class="flex justify-between flex-col bg-[#252A30] p-3 pl-4 h-[5.6rem]   border-[#343B4F] rounded-[0.5rem] ">
                <div class="flex  text-wrap items-center "><img src="../../assets/svg/totCapa.svg" alt="preview"
                        class="lg:w-4 lg:h-4 sm:w-[0.9rem] sm:h-[0.9rem]  ">
                    <span
                        class="font-normal  text-[#C3DEFF] sm:text-sm lg:text-lg tracking-[2%] ml-2 ">{{"totalCapacity"|
                        translate}}</span>
                </div>
                <span class="font-bold text-white sm:text-sm lg:text-xl text-nowrap">
                    {{largeScalePlantStats.totalCapacity??'0
                    MW' }}</span>
            </div>
            <div
                class="flex justify-between flex-col bg-[#252A30] p-3 pl-4 h-[5.6rem]   border-[#343B4F] rounded-[0.5rem] ">
                <div class="flex  text-wrap items-center"><img src="../../assets/svg/todGene.svg" alt="preview"
                        class="lg:w-4 lg:h-4 sm:w-[0.9rem] sm:h-[0.9rem]  ">
                    <span
                        class="font-normal  text-[#C3DEFF] sm:text-sm lg:text-lg tracking-[2%] ml-2 ">{{"todayGeneration"|translate}}</span>
                </div>
                <span class="font-bold text-white sm:text-sm lg:text-xl text-nowrap">
                    {{largeScalePlantStats.todayGeneration?? '0
                    kWh'}}</span>
            </div>
            <div
                class="flex justify-between flex-col bg-[#252A30] p-3 pl-4 h-[5.6rem]   border-[#343B4F] rounded-[0.5rem] ">
                <div class="flex  text-wrap  items-center "><img src="../../assets/svg/speciYield.svg" alt="preview"
                        class="lg:w-4 lg:h-4 sm:w-[0.9rem] sm:h-[0.9rem]  ">
                    <span
                        class="font-normal  text-[#C3DEFF] sm:text-sm lg:text-lg tracking-[2%] ml-2 ">{{"specificYield"|translate
                        }}</span>
                </div>
                <span class="font-semibold text-white sm:text-sm lg:text-xl text-nowrap">
                    {{largeScalePlantStats.specificYield ?? '0'
                    }}</span>
            </div>
            <div
                class="flex justify-between flex-col bg-[#252A30] p-3 pl-4 h-[5.6rem]   border-[#343B4F] rounded-[0.5rem] ">
                <div class="flex  text-wrap  items-center  "><img src="../../assets/svg/totGene.svg" alt="preview"
                        class="md:w-4 md:h-4 sm:w-[0.9rem] sm:h-[0.9rem]  ">
                    <span
                        class="font-normal  text-[#C3DEFF] sm:text-sm lg:text-lg tracking-[2%] ml-2  ">{{"totalGeneration"|translate}}</span>
                </div>
                <span class="font-bold text-white sm:text-sm lg:text-xl text-nowrap">
                    {{largeScalePlantStats.totalGeneration ??
                    '0 MWh' }}</span>
            </div>
            <div
                class="flex justify-between flex-col bg-[#252A30] p-3 pl-4 h-[5.6rem]   border-[#343B4F] rounded-[0.5rem] ">
                <div class="flex text-wrap  items-center "><img src="../../assets/svg/pr.svg" alt="preview"
                        class="lg:w-4 lg:h-4 sm:w-[0.9rem] sm:h-[0.9rem] ">
                    <span
                        class="font-normal  text-[#C3DEFF] sm:text-sm lg:text-lg tracking-[2%] ml-2 ">{{"pr"|translate}}</span>
                </div>
                <span class="font-bold text-white sm:text-sm lg:text-xl text-nowrap"> {{largeScalePlantStats.pr ?? '0
                    %'}}</span>
            </div>
            <div
                class="flex justify-between flex-col bg-[#252A30] p-3 pl-4 h-[5.6rem]   border-[#343B4F] rounded-[0.5rem] ">
                <div class="flex text-wrap   items-center "><img src="../../assets/svg/cuf.svg" alt="preview"
                        class="lg:w-4 lg:h-4 sm:w-[0.9rem] sm:h-[0.9rem] ">
                    <span
                        class="font-normal  text-[#C3DEFF] sm:text-sm lg:text-lg tracking-[2%] ml-2 ">{{"cuf"|translate}}</span>
                </div>
                <span class="font-bold text-white sm:text-sm lg:text-xl text-nowrap"> {{largeScalePlantStats.cuf??'0 %'
                    }}</span>
            </div>
            <div
                class="flex justify-between flex-col bg-[#252A30] p-3 pl-4 h-[5.6rem]   border-[#343B4F] rounded-[0.5rem] ">
                <div class="flex text-wrap  items-center "><img src="../../assets/svg/irradiance.svg" alt="preview"
                        class="lg:w-4 lg:h-4 sm:w-[0.9rem] sm:h-[0.9rem] ">
                    <span
                        class="font-normal  text-[#C3DEFF] sm:text-sm lg:text-lg tracking-[2%] ml-2 ">{{"irradiation"|translate}}</span>
                </div>
                <span class="font-bold text-white sm:text-sm lg:text-xl text-nowrap">
                    {{largeScalePlantStats.irradiance??'0'}}</span>
            </div>
            <div
                class="flex justify-between flex-col bg-[#252A30] p-3 pl-4 h-[5.6rem]   border-[#343B4F] rounded-[0.5rem] ">
                <div class="flex text-wrap   items-center "><img src="../../assets/svg/ambieTemp.svg" alt="preview"
                        class="lg:w-4 lg:h-4 sm:w-[0.9rem] sm:h-[0.9rem]  ">
                    <span
                        class="font-normal  text-[#C3DEFF] sm:text-sm lg:text-lg tracking-[2%] ml-2  ">{{"ambientTemperature"|translate}}</span>
                </div>
                <span class="font-bold text-white sm:text-sm lg:text-xl text-nowrap">
                    {{largeScalePlantStats.ambientTemperature
                    }}</span>
            </div>
            <div
                class="flex justify-between flex-col bg-[#252A30] p-3 pl-4 h-[5.6rem]   border-[#343B4F] rounded-[0.5rem] ">
                <div class="flex   text-wrap  items-center "><img src="../../assets/svg/module-temp.svg" alt="preview"
                        class="lg:w-4 lg:h-4 sm:w-[0.9rem] sm:h-[0.9rem]">
                    <span class="font-normal  text-[#C3DEFF] sm:text-sm lg:text-lg tracking-[2%] ml-2  ">{{
                        "moduleTemperature"|translate}}</span>

                </div>
                <span class="font-bold text-white sm:text-sm lg:text-xl text-nowrap">
                    {{largeScalePlantStats.moduleTemperature
                    }}</span>
            </div>
            <div
                class="flex justify-between flex-col bg-[#252A30] p-3 pl-4 h-[5.6rem]   border-[#343B4F] rounded-[0.5rem] ">
                <div class="flex   text-wrap  items-center  "><img src="../../assets/svg/devicesandonline.svg"
                        alt="preview" class="lg:w-4 lg:h-4 sm:w-[0.9rem] sm:h-[0.9rem]  ">
                    <span class="font-normal  text-[#C3DEFF] sm:text-sm lg:text-lg tracking-[2%] ml-2 ">{{
                        "devicesAndOnline"|translate }}</span>
                </div>
                <span class="font-bold text-white sm:text-sm lg:text-xl text-nowrap">
                    {{largeScalePlantStats.devicesAndOnline
                    }}</span>
            </div>
            <div
                class="flex justify-between flex-col bg-[#252A30] p-3 pl-4 h-[5.6rem]   border-[#343B4F] rounded-[0.5rem] ">
                <div class="flex text-wrap  items-center "><img src="../../assets/svg/peak-power (2).svg" alt="preview"
                        class="lg:w-4 lg:h-4 sm:w-[0.9rem] sm:h-[0.9rem] ">
                    <span class="font-normal  text-[#C3DEFF] sm:text-sm lg:text-lg tracking-[2%] ml-2">{{
                        "peakPower"|translate}}</span>
                </div>
                <span class="font-bold text-white sm:text-sm lg:text-xl text-nowrap"> {{largeScalePlantStats.peakPower
                    ?? '0 kW'
                    }}</span>
            </div>
            <div
                class="flex justify-between flex-col bg-[#252A30] p-3 pl-4 h-[5.6rem]   border-[#343B4F] rounded-[0.5rem] ">
                <div class="flex text-wrap  items-center "><img src="../../assets/svg/alert (2).svg" alt="preview"
                        class="lg:w-4 lg:h-4 sm:w-[0.9rem] sm:h-[0.9rem]  ">
                    <span
                        class="font-normal  text-[#C3DEFF] sm:text-sm lg:text-lg tracking-[2%] ml-2 ">{{"alert"|translate}}</span>
                </div>
                <span class="font-bold text-white sm:text-sm lg:text-xl text-nowrap"> {{largeScalePlantStats.alert??'0'
                    }}</span>
            </div>
        </div>}
        <!--Plant Generation and More Stats boxes-->
        <div class="w-full flex items-stretch sm:flex-col md:flex-row gap-1.5 ">

            <div
                class="md:w-[90%] sm:w-full    min-w-0  h-[23.5rem] bg-[#252A30]  p-3 pl-4 sm:min-h-52 md:min-h-64 border-[#343B4F] rounded-[0.5rem] md:items-stretch">
                @if (selectedPlant) {
                <app-large-scale-plant-generation [plantID]="selectedPlant.plantId"
                    class="flex-1 w-full"></app-large-scale-plant-generation>}
            </div>


            @if (largeScalePlantStats ) {
            <div
                class="md:flex sm:w-full md:w-[30%] sm:flex-row md:flex-col gap-1.5 sm:grid sm:grid-cols-3 items-stretch">
                <div
                    class="flex  flex-col bg-[#252A30]  p-3 pl-4 sm:min-h-20 md:min-h-[5.6rem] flex-grow  border-[#343B4F] rounded-[0.5rem] ">
                    <div class="flex w-full text-wrap items-center "><img src="../../assets/svg/trees_planted.svg"
                            alt="preview" class="md:w-5 md:h-5 sm:w-[0.9rem] sm:h-[0.9rem] ">
                        <span
                            class="font-normal  text-[#C3DEFF] sm:text-sm md:text-lg tracking-[2%] ml-2 ">{{"treesPlanted"|
                            translate}}</span>
                    </div>
                    <span class="font-bold text-white sm:text-base lg:text-xl mt-3 text-nowrap">
                        {{largeScalePlantStats.treesPlanted
                        ??'NA'}}</span>
                </div>
                <div
                    class="flex  flex-col bg-[#252A30] p-3 pl-4 sm:min-h-20  md:min-h-[5.6rem]  flex-grow  border-[#343B4F] rounded-[0.5rem] ">
                    <div class="flex w-full text-wrap items-center"><img src="../../assets/svg/co2_saved.svg"
                            alt="preview" class="md:w-5 md:h-5 sm:w-[0.9rem] sm:h-[0.9rem] ">
                        <span
                            class="font-normal  text-[#C3DEFF] sm:text-sm md:text-lg tracking-[2%] ml-2 ">{{"co2"|translate}}</span>
                    </div>
                    <span class="font-bold text-white sm:text-base lg:text-xl mt-3 text-nowrap">
                        {{largeScalePlantStats.co2??'O T'
                        }}</span>
                </div>
                <div
                    class="flex  flex-col bg-[#252A30] p-3 pl-4 sm:min-h-20  md:min-h-[5.6rem] flex-grow  border-[#343B4F] rounded-[0.5rem] ">
                    <div class="flex w-full text-wrap items-center"><img src="../../assets/svg/coal_not_burned.svg"
                            alt="preview" class="md:w-5  md:h-5 sm:w-[0.9rem] sm:h-[0.9rem] ">
                        <span
                            class="font-normal  text-[#C3DEFF] sm:text-sm md:text-lg tracking-[2%] ml-2 ">{{"coal_not_burned"|translate
                            }}</span>
                    </div>
                    <span class="font-bold text-white sm:text-base lg:text-xl mt-3 text-nowrap">
                        {{largeScalePlantStats.coalNotBurned??'NA' }}</span>
                </div>
            </div>}
        </div>
        <div
            class="w-full sm:grid md:flex  md:flex-row md:items-stretch gap-1.5 sm:h-fit  md:h-[26rem] overflow-x-hidden ">
            <!-- puf/cuf -->
            <div
                class="md:w-[50%] flex-1 sm:w-full min-w-0  flex  flex-col bg-[#252A30] p-3 pl-4 sm:h-fit md:h-full sm:min-h-52 md:min-h-0 border-[#343B4F] rounded-[0.5rem]">
                @if (selectedPlant) {
                <app-puf [plantID]="selectedPlant.plantId" class="h-full"></app-puf>
                }
            </div>
            <!--Today Generation -->

            <div
                class="md:w-[50%] flex-1 sm:w-full  min-w-0 flex  flex-col  bg-[#252A30] p-3 pl-4 sm:h-fit md:h-full sm:min-h-52 md:min-h-0 border-[#343B4F] rounded-[0.5rem]">
                @if (selectedPlant) {
                <app-large-scale-today-generation [plantID]="selectedPlant.plantId"
                    class="h-full"></app-large-scale-today-generation>
                }
            </div>
        </div>
        <!--Power Generation -->
        <div
            class="md:w-full sm:grid  sm:w-full  min-w-0 md:flex  sm:min-h-64 lg:min-h-72  flex-col bg-[#252A30] p-3 pl-4  sm:h-fit md:h-full border-[#343B4F] rounded-[0.5rem]">
            @if (selectedPlant) {
            <app-large-scale-power-generation [plantID]="selectedPlant.plantId"
                class="w-full max-w-full "></app-large-scale-power-generation>
            }
        </div>
        <!--Inverter String ,Meters ,Sensor and Site Info -->
        <div
            class="flex flex-col w-full bg-[#252A30] p-3 pl-4   border-[#343B4F] rounded-[0.5rem] overflow-x-hidden max-w-full">
            <div class="flex justify-center w-full gap-1 mb-2 flex-wrap ">
                <button
                    class="bg-[#343B43] text-white py-[1.13rem] sm:px-3 md:px-6  flex justify-center items-center text-nowrap h-8 w-fit sm:min-w-20 md:min-w-[9rem] border-none rounded-[4px]  border-[#433C3C] font-normal sm:text-base md:text-xl"
                    (click)="buttonSelected(TabType.INVERTER_STRING)"
                    [class.tab-active]="selectedTab==='inverterString'">Inverter String </button>
                <button
                    class="bg-[#343B43] text-white py-[1.13rem] sm:px-3 md:px-6  flex justify-center items-center text-nowrap h-8 w-fit sm:min-w-20 md:min-w-[9rem] border-none rounded-[4px]  border-[#433C3C] font-normal sm:text-base md:text-xl"
                    (click)="buttonSelected(TabType.METERS)" [class.tab-active]="selectedTab==='meters'">Meters</button>
                <button
                    class="bg-[#343B43] text-white py-[1.13rem] sm:px-3 md:px-6  flex justify-center items-center text-nowrap h-8 w-fit sm:min-w-20 md:min-w-[9rem] border-none rounded-[4px]  border-[#433C3C] font-normal sm:text-base md:text-xl"
                    (click)="buttonSelected(TabType.SENSORS)"
                    [class.tab-active]="selectedTab==='sensors'">Sensors</button>
                <button
                    class="bg-[#343B43] text-white py-[1.13rem] sm:px-3 md:px-6  flex justify-center items-center text-nowrap h-8 w-fit sm:min-w-20 md:min-w-[9rem] border-none rounded-[4px]  border-[#433C3C] font-normal sm:text-base md:text-xl"
                    (click)="buttonSelected(TabType.SITE_INFO)" [class.tab-active]="selectedTab==='siteInfo'">Site
                    Info</button>
            </div>
            <div class="text-white w-full  overflow-x-hidden grid grid-flow-row ">
                @if (selectedTab===TabType.INVERTER_STRING) {
                <div class="  w-full max-w-full overflow-x-auto ">
                    <table class="re table-auto w-full  border-separate border-spacing-x-1 border-spacing-y-1 ">
                        <thead>
                            <tr class="text-white ">
                                <th
                                    class="p-2 border border-[#343B4F] sm:font-medium md:font-semibold sm:text-sm md:text-base bg-[#333940] whitespace-nowrap text-center sticky-col sticky-col-shadow">
                                    Name</th>
                                @for(inverter of inverterKeys;track $index){
                                <th
                                    class="p-2 border border-[#343B4F] sm:font-medium md:font-semibold sm:text-sm md:text-base bg-[#333940] whitespace-nowrap text-center">
                                    {{ formatInverterName( inverter)}}
                                </th>}
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="w-full border-0 p-0 h-0 "></tr>
                            @for(stringName of stringKeys;track $index){
                            <tr class="text-center w-full">
                                <td
                                    class="p-2 border sm:font-medium md:font-semibold sm:text-xs md:text-base border-[#343B4F] bg-[#333940] whitespace-nowrap sticky-col sticky-col-shadow">
                                    {{ stringName }}
                                </td>

                                <td *ngFor="let inverter of inverterKeys"
                                    class="p-2 border  border-[#343B4F] bg-[#333940] whitespace-nowrap"
                                    [class.cell-red]="getStringValue(inverter, stringName) === 0"
                                    [class.cell-green]="getStringValue(inverter, stringName) !== null && getStringValue(inverter, stringName) !== undefined && getStringValue(inverter, stringName) !== 0">
                                    {{ getStringValue(inverter, stringName) }}
                                </td>
                            </tr>}
                        </tbody>
                    </table>
                </div>

                }
                @if (selectedTab===TabType.METERS) {
                <div class="w-full overflow-x-auto">
                    <table
                        class="w-full min-w-[1000px] table-auto  border-separate border-spacing-x-1 border-spacing-y-1 ">
                        <thead>
                            <tr class="text-white ">
                                @for (key of meterKeys; track $index) {
                                <th class="p-2 border border-[#343B4F] sm:font-medium md:font-semibold sm:text-sm md:text-base bg-[#333940] whitespace-nowrap text-center"
                                    [class.sticky-col]="$index === 0" [class.sticky-col-shadow]="$index === 0">
                                    {{ meterItems[key] || (key | capitalize) }} </th>
                                }
                            </tr>
                        </thead>
                        <tbody class="text-white ">
                            <tr class="w-full border-0 p-0 h-0 "></tr>
                            @for (row of meterRows; track $index) {
                            <tr class="text-center w-full">
                                @for (value of row; track $index) {
                                <td class="p-2 border font-normal text-[17px] first:sm:font-medium first:sm:text-xs  first:md:font-semibold first:md:text-[17px] border-[#343B4F] bg-[#333940] whitespace-nowrap"
                                    [class.sticky-col]="$index === 0" [class.sticky-col-shadow]="$index === 0">
                                    {{ value ?? '-' }}
                                </td>
                                }
                            </tr>
                            }
                        </tbody>
                    </table>
                </div>
                }
                @if (selectedTab===TabType.SENSORS) {
                <div class="w-full overflow-x-auto">
                    <table
                        class="w-full min-w-[1000px] table-auto  border-separate border-spacing-x-1 border-spacing-y-1 ">
                        <thead>
                            <tr class="text-white ">
                                @for (item of sensorItems; track $index) {
                                @if (item.label=='Sensor Name'|| item.label=='Last Updated') {
                                <th class="p-2 border border-[#343B4F] sm:font-medium md:font-semibold sm:text-sm md:text-base  bg-[#333940] whitespace-nowrap text-center"
                                    [class.sticky-col]="$index === 0"
                                     [class.sticky-col-shadow]="$index === 0">
                                    {{ item.label + item.unit }}
                                </th>
                                }@else{

                                <th class="p-2 border border-[#343B4F] sm:font-normal md:font-normal sm:text-sm md:text-[17px] bg-[#333940] whitespace-nowrap text-center"
                                    [class.sticky-col]="$index === 0" [class.sticky-col-shadow]="$index === 0">
                                    {{ item.label + ' (' + item.unit + ')' }}
                                </th>}
                                }
                            </tr>
                        </thead>
                        <tbody class="text-white ">
                            <tr class="w-full border-0 p-0 h-0 "></tr>
                            @for (item of sensors; track $index) {
                            <tr class="text-center">
                                <td
                                    class="p-2 border border-[#343B4F] sm:font-medium md:font-semibold sm:text-xs md:text-[17px] bg-[#333940] whitespace-nowrap sticky-col sticky-col-shadow">
                                    {{item.sensorName??'-'}}
                                </td>
                                <td
                                    class="p-2 border border-[#343B4F] font-normal text-[17px] bg-[#333940] whitespace-nowrap ">
                                    {{item.irradiation??'-'}}
                                </td>
                                <td
                                    class="p-2 border border-[#343B4F] font-normal text-[17px] bg-[#333940] whitespace-nowrap">
                                    {{item.windDirection??'-'}}
                                </td>
                                <td
                                    class="p-2 border border-[#343B4F] font-normal text-[17px] bg-[#333940] whitespace-nowrap ">
                                    {{item.windSpeed??'-'}}
                                </td>
                                <td
                                    class="p-2 border border-[#343B4F] font-normal text-[17px] bg-[#333940] whitespace-nowrap ">
                                    {{item.ambientTemperature??'-'}}
                                </td>
                                <td
                                    class="p-2 border border-[#343B4F] font-normal text-[17px] bg-[#333940] whitespace-nowrap ">
                                    {{item.moduleTemperature??'-'}}
                                </td>

                                <td
                                    class="p-2 border border-[#343B4F] font-normal  text-[17px] bg-[#333940] whitespace-nowrap ">
                                    {{dateFormatter(item.lastUpdated)}}
                                </td>
                            </tr>
                            }
                        </tbody>
                    </table>
                </div>
                }
                @if (selectedTab===TabType.SITE_INFO) {
                <div class="w-full overflow-x-auto">
                    <table
                        class="w-full min-w-[1000px] table-auto  border-separate border-spacing-x-1 border-spacing-y-1 ">
                        <thead>
                            <tr class="text-white ">
                                @for (item of siteInfoItems; track $index) {
                                <th class="p-2 border border-[#343B4F] sm:font-medium md:font-semibold sm:text-sm md:text-base bg-[#333940] whitespace-nowrap text-center"
                                    [class.sticky-col]="$index === 0" [class.sticky-col-shadow]="$index === 0">
                                    {{ item.label }}
                                </th>
                                }
                            </tr>
                        </thead>
                        <tbody class="text-white ">
                            <tr class="w-full border-0 p-0 h-0 "></tr>
                            <tr class="text-center">
                                @for (item of siteInfoItems; track $index) {
                                <td class="p-2 border border-[#343B4F] font-normal  text-[17px] first:sm:font-medium first:sm:text-xs first:md:font-semibold first:md:text-[17px] bg-[#333940] whitespace-nowrap"
                                    [class.sticky-col]="$index === 0" [class.sticky-col-shadow]="$index === 0">
                                    {{ siteInfo?.[item.key]??'-' }}
                                </td>
                                }
                            </tr>
                        </tbody>
                    </table>
                </div>
                }
            </div>
        </div>
    </div>
</div>